/* eslint-disable */
import * as Types from '../../../../../../generated/graphql'

import { gql } from '@apollo/client'
export type GQLTravelAtlasFragment = {
  __typename?: 'PublicProfile'
  travelAtlas: {
    __typename?: 'PublicTravelAtlas'
    visitedCountries: {
      __typename?: 'PublicTravelAtlasVisitedCountries'
      visitedCountriesCount: number
      visitedCountries: {
        __typename?: 'PublicTravelAtlasVisitedCountriesConnection'
        nodes: Array<{
          __typename?: 'PublicTravelAtlasVisitedCountry'
          date: string
          country: {
            __typename?: 'Country'
            id: string
            name: string
            code: string
            isoCode: string
          }
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
    badges: {
      __typename?: 'PublicTravelAtlasBadges'
      badgesCount: number
      badges: {
        __typename?: 'PublicTravelAtlasBadgesConnection'
        nodes: Array<{
          __typename?: 'PublicTravelAtlasBadge'
          id: number
          name: string
          desc: string
          image: string
        }>
        pageInfo: {
          __typename?: 'PageInfo'
          hasNextPage: boolean
          endCursor: any
        }
      }
    }
  }
}

export const TravelAtlasFragmentDoc = gql`
  fragment TravelAtlas on PublicProfile {
    travelAtlas {
      visitedCountries {
        visitedCountriesCount
        visitedCountries(limit: $limitCountries, after: null) {
          nodes {
            country {
              id
              name
              code
              isoCode
            }
            date
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
      badges {
        badges(limit: 100, after: null) {
          nodes {
            id
            name
            desc
            image
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
        badgesCount
      }
    }
  }
`
